import { render, staticRenderFns } from "./TravelRequests.vue?vue&type=template&id=450f940f&scoped=true"
import script from "./TravelRequests.vue?vue&type=script&lang=js"
export * from "./TravelRequests.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "450f940f",
  null
  
)

export default component.exports